import { useEffect, useState } from 'react';
export default function useScrollY() {
  // const [scrollPosition, setScrolPosition] = useState(0);
  const [scrollPositionChanged, setScrolPositionChanges] = useState(false);

  const handleScroll = () => {
    const position = window.pageYOffset;
    // setScrolPositionChanges(position <= 0);
    if (position > 1) {
      setScrolPositionChanges(true);
    } else {
      setScrolPositionChanges(false);
    }
    // setScrolPosition(+position.toFixed(0));
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return scrollPositionChanged;
}
